import {
  FleetVehicleStatusDetailFormValues,
  FleetVehicleStatusEnum,
} from "services/api/fleet/vehicles/types";
import { VehicleLocationFormValues } from "services/api/fleet/vehicles/locations/types";
import { Errors } from "services/forms/validation/types";

export interface VehicleStatusDetailFormProps {
  vehicleId: string;
  status: FleetVehicleStatusEnum;
  values: FleetVehicleStatusDetailFormValues;
  errors: Errors;
  /** Mijenja samo navedena polja — korak ne zna za ostatak forme. */
  onChange: (patch: Partial<FleetVehicleStatusDetailFormValues>) => void;
  onLocationChange: (location: VehicleLocationFormValues) => void;
}

/**
 * Odakle dolaze podaci rezervacije. Ponuda već nosi kupca i rok, pa se biraju ili
 * ponuda ili ručni unos — ne oboje.
 */
export enum VehicleReservationSourceEnum {
  OFFER = "OFFER",
  MANUAL = "MANUAL",
}

/**
 * Zajednički ugovor svih komponenti s poljima po statusu. Jedan oblik za sve, pa ih
 * registar u consts.ts može držati u istoj mapi.
 */
export interface VehicleStatusFieldsProps {
  status: FleetVehicleStatusEnum;
  vehicleId: string;
  values: FleetVehicleStatusDetailFormValues;
  errors: Errors;
  /** Mijenja samo navedena polja — komponenta ne zna za ostatak forme. */
  onChange: (patch: Partial<FleetVehicleStatusDetailFormValues>) => void;
  /** Korak je prikazan — komponente koje dohvaćaju podatke kreću tek tada. */
  show: boolean;
}
